import { Collapse, Divider, List, ListItem, ListItemIcon, ListItemText, ListSubheader, Typography } from "@material-ui/core";

import { ContactSupport, Dashboard, Error, Event, ExpandLess, ExpandMore, GroupAdd, Home, LeakAdd, NotificationImportant, Person, Policy, School, Shop } from "@material-ui/icons";

import React, { useState } from "react";
import { SignOutListItem, SignOutMenuItem } from "../SignOut";
import * as ROUTES from "../../constants/routes";
import { useHistory } from "react-router-dom";
import { AuthUserContext } from "../Session";
import { useTranslation } from "react-i18next";
import moment from "moment";
import LangSelect from "../Navigation/LangSelect";

const AuthDrawer = ({ user, setanchor }) => {
    const [open, setopen] = useState(false);
    const [formationOpen, setFormationOpen] = useState(false);
    const { t, i18n } = useTranslation();

    let history = useHistory();

    const onChangeLanguaje = (lang) => {
        i18n.changeLanguage(lang);
    };

    return (
        <div style={{ overflowX: "hidden" }}>
            <div
                style={{
                    height: 175,
                    backgroundColor: "rgb(153, 51, 204)",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "row",
                }}
            >
                <div
                    style={{
                        flexDirection: "row",
                        alignItems: "center",
                        paddingTop: 48,
                    }}
                >
                    <div
                        style={{
                            backgroundColor: "white",
                            width: 64,
                            height: 64,
                            borderRadius: 32,
                            marginLeft: 32,
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        <Person style={{ fontSize: 64 }} />
                    </div>
                    <div
                        style={{
                            marginLeft: 19,
                            marginTop: 18,
                        }}
                    >
                        <Typography variant="body1" style={{ fontSize: 18, fontWeight: 500, color: "white", justifyItems: "stretch" }}>
                            {t("nav.hello", { name: user.displayName })}
                            {`    `}
                            <div style={{ right: -140, top: -30, position: "relative" }}>
                                <LangSelect icon />
                            </div>
                        </Typography>
                    </div>
                </div>
            </div>

            <List
                //onClick={() => setanchor(false)}
                style={{ width: 250 }}
            >
                <ListItem
                    button
                    key={1}
                    onClick={() => {
                        history.push(ROUTES.HOME);
                        setanchor(false);
                    }}
                >
                    <ListItemIcon>
                        <Home color="primary" />
                    </ListItemIcon>
                    <ListItemText primary={t("home")} />
                </ListItem>
                <AuthUserContext.Consumer>
                    {(auth) => (
                        <ListItem
                            button
                            key={2}
                            onClick={() => {
                                history.push(ROUTES.PROFILE.replace(":uid", auth.uid));
                                setanchor(false);
                            }}
                        >
                            <ListItemIcon>
                                <Person color="primary" />
                            </ListItemIcon>
                            <ListItemText primary={t("perfil")} />
                        </ListItem>
                    )}
                </AuthUserContext.Consumer>

                {/* <ListItem button onClick={() => setFormationOpen(!formationOpen)}>
          <ListItemIcon>
            <School color="primary" />
          </ListItemIcon>
          <ListItemText primary={t("formation")} />
          {formationOpen ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        <Collapse in={formationOpen} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItem button onClick={() => (history.push("/course/FCSReconocimientoPrecoz"), setanchor(false))}>
              <ListItemText primary={t("course1")} style={{ paddingLeft: 24 }} />
            </ListItem>
            <ListItem button onClick={() => (history.push("/course/FCSRCPPrecoz"), setanchor(false))}>
              <ListItemText primary={t("course2")} style={{ paddingLeft: 24 }} />
            </ListItem>
            <ListItem button onClick={() => (history.push("/course/FCSDesfibrilacionPrecoz"), setanchor(false))}>
              <ListItemText primary={t("course3")} style={{ paddingLeft: 24 }} />
            </ListItem>
          </List>
          {formationOpen && <Divider />}
        </Collapse>
        */}
                <AuthUserContext.Consumer>
                    {(authUser) => {
                        const nextSchedule = authUser?.sgpfc?.onSiteTrainings?.next;
                        let nextScheduleText = t("noSchedule");
                        let NewUser = moment(authUser?.sgpfc?.onSiteTrainings?.next?.time);
                        if (NewUser.isAfter(moment())) {
                            nextSchedule.time = NewUser;
                        }
                        if (!!nextSchedule && !!nextSchedule?.time) {
                            if (moment(nextSchedule.time).isAfter(moment())) {
                                nextScheduleText = moment(nextSchedule.time).format("dddd DD MMMM · HH:mm");
                            }
                        }

                        return (
                            <ListItem button key={0} onClick={() => (history.push(ROUTES.ONSITE_TRAINING), setanchor(false))}>
                                <ListItemIcon>
                                    <Event color="primary" />
                                </ListItemIcon>
                                <ListItemText primary={t("nextCourses")} secondary={nextScheduleText} />
                            </ListItem>
                        );
                    }}
                </AuthUserContext.Consumer>

                {/*<ListItem button key={1} onClick={() => history.push(ROUTES.HOME)}>
          <ListItemIcon>
            <School color="primary" />
          </ListItemIcon>
          <ListItemText
            primary={currentLang === "es" ? "Formación" : "Formation"}
          />
        </ListItem>*/}

                {/* <ListItem
          button
          key={2}
          onClick={() => history.push(ROUTES.EVALUATIONS)}
        >
          <ListItemIcon>
            <Help color="primary" />
          </ListItemIcon>
          <ListItemText
            primary={currentLang === "es" ? "Evaluaciones" : "Evaluations"}
          />
        </ListItem>*/}
            </List>

            <AuthUserContext.Consumer>
                {(authUser) =>
                    (authUser.sgpfc.alertAccess || authUser.sgpfc.alertAccess == undefined) && (
                        <List
                            style={{ width: 250 }}
                            subheader={
                                <ListSubheader component="div" id="user-subheader">
                                    {t("apps")}
                                </ListSubheader>
                            }
                        >
                            <ListItem button key={0} onClick={() => (window.open("https://play.google.com/store/apps/details?id=com.reanibex_alert&gl=ES"), setanchor(false))}>
                                <ListItemIcon>
                                    <Shop color="primary" />
                                </ListItemIcon>
                                <ListItemText primary={"Reanibex Alert"} />
                            </ListItem>
                        </List>
                    )
                }
            </AuthUserContext.Consumer>

            <AuthUserContext.Consumer>
                {(authUser) =>
                    authUser.sgpfc.rol === "manager" ||
                    (authUser.sgpfc.rol === "admin" && (
                        <List
                            style={{ width: 250 }}
                            subheader={
                                <ListSubheader component="div" id="user-subheader">
                                    {t("managerResources")}
                                </ListSubheader>
                            }
                        >
                            <ListItem button onClick={() => (history.push(ROUTES.MANAGER), setanchor(false))}>
                                <ListItemIcon>
                                    <Dashboard color="primary" />
                                </ListItemIcon>
                                <ListItemText primary={t("results")} />
                            </ListItem>

                            <ListItem button onClick={() => (history.push(ROUTES.PROGRAMMANAGEMENT), setanchor(false))}>
                                <ListItemIcon>
                                    <Dashboard color="primary" />
                                </ListItemIcon>
                                <ListItemText primary={"Gestion de programas"} />
                            </ListItem>
                            <ListItem button onClick={() => (history.push(ROUTES.MANAGE_FORMS), setanchor(false))}>
                                <ListItemIcon>
                                    <GroupAdd color="primary" />
                                </ListItemIcon>
                                <ListItemText primary={"Gestión de registros"} />
                            </ListItem>
                            <ListItem button onClick={() => (history.push(ROUTES.REAL_TIME_ALERS), setanchor(false))}>
                                <ListItemIcon>
                                    <NotificationImportant color="primary" />
                                </ListItemIcon>
                                <ListItemText primary={"Alertas"} />
                            </ListItem>
                            <ListItem button onClick={() => (history.push(ROUTES.COMUNICATIONTEST), setanchor(false))}>
                                <ListItemIcon>
                                    <LeakAdd color="primary" />
                                </ListItemIcon>
                                <ListItemText primary={"Comunicaciones"} />
                            </ListItem>
                        </List>
                    ))
                }
            </AuthUserContext.Consumer>

            <List
                style={{ width: 250 }}
                subheader={
                    <ListSubheader component="div" id="user-subheader">
                        {t("help")}
                    </ListSubheader>
                }
            >
                <ListItem button onClick={() => (history.push(ROUTES.SENDREPORT), setanchor(false))}>
                    <ListItemIcon>
                        <ContactSupport color="primary" />
                    </ListItemIcon>
                    <ListItemText primary={t("contactanos")} />
                </ListItem>
                <ListItem button onClick={() => (history.push(ROUTES.REANIBEX_ALERT_POLICY), setanchor(false))}>
                    <ListItemIcon>
                        <Policy color="primary" />
                    </ListItemIcon>
                    <ListItemText primary={t("confPolicity")} />
                </ListItem>
            </List>
        </div>
    );
};

export default AuthDrawer;
